"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnClickOut = void 0;
const react_1 = require("react");
/**
 * @author Renan Salustiano<renan.salustiano@ter.grupomarista.org.br>
 */
const useOnClickOut = () => {
    const targetRef = (0, react_1.useRef)(null);
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const handleClickOutside = (event) => {
            if (targetRef.current &&
                !targetRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        // @ts-ignore
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            // @ts-ignore
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    return {
        isOpen,
        setIsOpen,
        targetRef,
    };
};
exports.useOnClickOut = useOnClickOut;
